module.exports = __webpack_public_path__ + "img/play-store.6c0aa90f.svg";